import React from "react";
import { Link } from "react-router-dom";

const policies = [
  { name: "Accident & Incident Management Policy", path: "accident-incident-management" },
  { name: "Anti-Bribery and Corruption Policy", path: "anti-bribery-corruption" },
  { name: "Breakdown and Recovery Procedure", path: "breakdown-recovery" },
  { name: "Cargo Handling & Security Policy", path: "cargo-handling-security" },
  { name: "Communication & Reporting Policy", path: "communication-reporting" },
  { name: "Compliance & Regulatory Policy", path: "compliance-regulatory" },
  { name: "Customer Service Policy", path: "customer-service" },
  { name: "Data Protection Policy (GDPR)", path: "data-protection-gdpr" },
  { name: "Driver Handbook / Employee Policy", path: "driver-handbook" },
  { name: "Driver Performance Monitoring Policy", path: "driver-performance-monitoring" },
  { name: "Driver Recruitment & Selection Policy", path: "driver-recruitment-selection" },
  { name: "Drug & Alcohol Policy", path: "drug-alcohol" },
  { name: "Emergency Response Plan", path: "emergency-response-plan" },
  { name: "Employee Grievance Procedure", path: "employee-grievance-procedure" },
  { name: "Employee Policy", path: "employee-policy" },
  { name: "Environmental Policy", path: "environmental" },
  { name: "Equal Opportunities and Diversity Policy", path: "equal-opportunities" },
  { name: "Fleet Management Policy", path: "fleet-management" },
  { name: "Flexible Working Policy", path: "flexible-working" },
  { name: "Fuel Management Policy", path: "fuel-management" },
  { name: "Health & Safety Policy", path: "health-safety" },
  { name: "Health and Wellbeing Policy", path: "health-wellbeing" },
  { name: "Insurance & Liability Policy", path: "insurance-liability" },
  { name: "Invoicing Policy", path: "InvoicingPolicy" },
  { name: "IT and Communications Policy", path: "it-communications" },
  { name: "Load Security and Safe Loading Policy", path: "load-security-safe-loading" },
  { name: "Maternity / Paternity Policy", path: "maternity-paternity" },
  { name: "Pregnancy Policy", path: "PregnancyPolicy" },
  { name: "Quality Assurance Policy", path: "quality-assurance" },
  { name: "Redundancy Policy", path: "RedundancyPolicy" },
  { name: "Return to Work Policy", path: "return-to-work" },
  { name: "Roadworthiness & Maintenance Policy", path: "roadworthiness-maintenance" },
  { name: "Risk Management Policy", path: "risk-management" },
  { name: "Social Media Policy", path: "social-media" },
  { name: "Subcontractor Management Policy", path: "subcontractor-management" },
  { name: "Sustainability Policy", path: "sustainability" },
  { name: "Tachograph & Drivers' Hours Policy", path: "tachograph-drivers-hours" },
  { name: "Temporary Worker / Agency Worker Policy", path: "temporary-worker-agency-worker" },
  { name: "Training and Development Policy", path: "training-development" },
  { name: "Vehicle Security Policy", path: "vehicle-security" },
  { name: "Vehicle Maintenance Policy", path: "maintenance" },
  { name: "VOR (Vehicle Off Road) Policy", path: "vor-policy" },
  { name: "Wheel Off Policy", path: "wheel-off" },
  { name: "Whistleblowing Policy", path: "whistleblowing" },
  { name: "Workplace Bullying and Harassment Policy", path: "workplace-bullying-harassment" },
  { name: "Zero Tolerance Policy", path: "zero-tolerance" }
  // Add other policies here
];

function PoliciesPage() {
  return (
    <div className="p-6 bg-white">
      <h2 className="text-3xl font-bold mb-6 text-center">Policies</h2>
      
      {/* List of Policies as Buttons */}
      <div className="flex flex-col items-center space-y-2flex flex-col items-center space-y-4 max-w-lg mx-auto">
        {policies.map((policy, index) => (
          <Link
            key={index}
            to={`/policy/${policy.path}`}
            className="w-full bg-blue-500 text-white text-bold p-4 rounded-lg hover:bg-blue-600 transition-colors shadow-lg text-center"
          >
            {policy.name}
          </Link>
        ))}
      </div>
    </div>
  );
}

export default PoliciesPage;